import React, { useMemo, useState } from 'react';

import classNames from 'classnames/bind';

// Utils
import { Text, Button } from '@beef/ui-kit';

import { shallowEqual, useSelector } from 'react-redux';
import styles from './styles.pcss';
import { formatTodayYesterday } from '../../utils/formatString';
import { TableError } from './TableError';

const cx = classNames.bind(styles);

const NewTable = ({
  tableBody,
  desktopColumns,
  mobileColumns,
  columnFormatter = (x) => x,
  dateGetter,
  textError,
  serverError,
  handlerUpdateTable,
  showDate = true,
  entriesPerPage = 100,
}) => {
  // { '24.11.2021': [rec1, rec2, ...]}
  const { tableFilters } = useSelector(({ detalizationNew }) => ({
    tableFilters: detalizationNew.expenses.tableFilters,
  }), shallowEqual);

  const [currentLimit, setLimit] = useState(entriesPerPage);
  const addLimit = () => setLimit(currentLimit + entriesPerPage);

  const filteredBody = useMemo(() => tableBody
    .filter((col) => Object.values(tableFilters).every((filter) => filter(col))), [tableFilters, tableBody]);

  const groupedBody = useMemo(() => filteredBody.slice(0, currentLimit).reduce((acc, col) => {
    const date = formatTodayYesterday(dateGetter(col));
    if (!acc[date]) acc[date] = [];
    acc[date].push(col);
    return acc;
  }, {}), [currentLimit, filteredBody]);

  const isDisplayMoreButton = useMemo(() => filteredBody.length > currentLimit, [currentLimit, groupedBody]);

  return (
    <>
      <div className={cx('table')}>
        <div className={cx('table-head')}>
          <div className={cx('table-head__row')}>
            {desktopColumns.map((head) => (
              <div className={cx('table-head__col',
                { 'table-head--img': head.modify === 'img' },
                `table--col-size-${head.colSize}`)}
              >
                <Text tagType="span" color="grey50" size="size7-r">{head.title}</Text>
              </div>
            ))}
          </div>
        </div>
        {((tableBody.length < 1 && !serverError) || Object.keys(groupedBody).length < 1) && (
          <TableError text={textError} errorType="empty" />
        )}

        { serverError && <TableError handlerUpdateTable={handlerUpdateTable} errorType="serverError" />}
        <div className={cx('table-body')}>
          {Object.entries(groupedBody).map(([date, records], groupId) => (
            <>
              {records.length !== 0
                  && (
                    showDate && (
                    <div key={groupId} className={cx('table-body__row')}>
                      <div className={cx('table-body__col table-body__date')}>
                        <Text tagType="span" color="grey50" size="size6-m">{date}</Text>
                      </div>
                    </div>
                    )
                  )}
              {records.map((record, recId) => (
                <>
                  <div key={recId} className={cx('table-body__row', 'table-body--desktop')}>
                    {desktopColumns.map((column, colId) => (
                      <div
                        key={colId}
                        title={column.title === 'Время' ? '' : column.data(record)}
                        className={cx('table-body__col',
                          { 'table-body--img': column.modify === 'img' },
                          `table--col-size-${column.colSize}`)}
                      >
                        <Text tagType="span" color={column.textColor ?? 'grey95'} size="size6-r">{(column.formatter ?? columnFormatter)(column.data(record))}</Text>
                      </div>
                    ))}
                  </div>
                  <div className={cx('table-body__row', 'table-body--mobile')}>
                    {Object.values(mobileColumns).map((column, colId) => (
                      <div key={colId} className={cx('table-body__col', ...(column.classes ?? []))}>
                        <Text tagType="span" color={column.color ?? 'grey95'} size="size6-r">
                          {(column.formatter ?? columnFormatter)(column.data(record))}
                        </Text>
                      </div>
                    ))}
                  </div>
                </>
              ))}
            </>
          ))}
          { isDisplayMoreButton && <Button type="button" onClick={addLimit} variant="tertiary">Показать ещё</Button>}
        </div>
      </div>
    </>
  );
};

export default NewTable;
